import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import styles from './styles.scss';

export default function Separator({ cols }) {
    return (
        <tr>
            <td colSpan={cols}>
                <div className={styles.separator} />
            </td>
        </tr>
    );
}

Separator.displayName = displayName('Forms/InputGroup/Separator');

Separator.propTypes = {
    cols: PropTypes.number.isRequired,
};
